export const experiences = [
  {
     _id: "1",
    company: "Syd Solution Tech",
    title: "Web Developer",
    period: "Oct 2025 - Present",
    description: "Developed and maintained web applications using Next.js and modern web technologies, focusing on ecommerce and POS features such as checkout, admin panels, and APIs. Enhanced responsiveness, performance, and overall code quality."  },
  {
    _id: "2",
    company: "Queue Lynx Drug Testing Center",
    title: "ASC",
    period: "Aug 2022 - Oct 2025",
    description: "Since 2022, I have been working as an Authorized Specimen Collector (ASC) at Queue Lynx Drug Testing Laboratory in Iriga City, where I provide front desk support and manage client logs. My responsibilities include maintaining PC workstations, performing basic hardware and software troubleshooting, conducting minor network and printer setups, and ensuring accurate data management with secure handling of digital records .",
  },
    {
    _id: "3",
    company: "CSPC - AI Research Center for Community Development",
    title: "Device Developer",
    period: "March 2025 - April 2025",
    description:
      "During my 224-hour On-the-Job Training at the Artificial Intelligence Research Center for Community Development (AIRCoDe), I was part of the Game Development Team under the Disaster Risk Management Division. Our main project was “Demon’s Maze”, a 3D maze-escape game developed using the Godot Engine and GDScript. The game featured AI-driven enemies using A* pathfinding and was showcased at the 13th Bicol Youth Congress in Information Technology (BYCIT) as part of AIRCoDe’s “AI Caravan for Community Development.” I contributed to enemy AI implementation, level design, and UI systems such as health and stamina. This experience sharpened my skills in game programming, team collaboration, and real-world project execution.",
  },
  
]
